import featureFlagService from "../services/featureFlagService";
import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../constants/queryKeys";

const useFeatureFlag = (featureName) =>
    useQuery([queryKeys.featureFlag, featureName], () => featureFlagService.getFeatureFlag(featureName), {
        enabled: !!featureName,
        staleTime: Infinity,
    });

export default useFeatureFlag;
